module.exports = __webpack_public_path__ + "img/thumbnail_Jaguar_f_albino.36de547d.png";